// De labels van het plan als knoppen: een statuslabel vervangt het andere (lib/cleanup.setLabelOps), zoals in Verloop.
// Gedeeld door de taaklade en de taakpagina; wie niet mag wijzigen, ziet de knoppen uitgeschakeld (always).
import { labelColor } from "../../lib/board";
import { replacedBy, setLabelOps } from "../../lib/cleanup";
import type { PlanningData, Task, TaskOp } from "../../lib/types";
import type { TaskPerm } from "./perm";

export function LabelsSection({ task, data, perm, run, always }: { task: Task; data: PlanningData; perm: TaskPerm; run: (ops: TaskOp[], message: string) => void; always?: boolean }) {
  if (!perm.edit && !always) return null;
  const labels = data.labels.filter((l) => l.projectId === task.projectId).sort((a, b) => a.name.localeCompare(b.name));
  return (
    <div className="p-quick">
      {labels.map((l) => {
        const has = task.labels.some((x) => x.id === l.id);
        const gone = has ? [] : replacedBy(task, l);
        const msg = has ? "Label weg: " + l.name : gone.length ? "Label " + l.name + " in plaats van " + gone.map((x) => x.name).join(" en ") : "Label erbij: " + l.name;
        return (
          <button key={l.id} type="button" className={"p-tog" + (has ? " on" : "")} aria-pressed={has} disabled={!perm.edit}
            onClick={() => run(has ? [{ kind: "label", labelId: l.id, on: false }] : setLabelOps(task, l), msg)}>
            <span className="p-lbl"><i style={{ background: labelColor(l.name) }} />{l.name}</span>
          </button>
        );
      })}
      {!labels.length && <span className="t-mute" style={{ fontSize: 13 }}>Dit plan heeft geen labels.</span>}
    </div>
  );
}
